import React, { useState } from 'react'
import PropTypes from 'prop-types'

import LogInContext from '../../../../context/LogInContext'
import { determineRedirectAndKeyword } from '../../../../helpers/lightbox'

function createUrlWithParams(url, params) {
  const urlObj = new URL(url)
  params.forEach(([key, value]) => {
    urlObj.searchParams.set(key, value)
  })
  return urlObj
}

function AppButtonV3({
  className,
  children,
  dataEvent,
  productType,
  landingKeyword,
  extraApplyParams,
  odsData,
  onMouseOver,
  segmentEvent,
  parentComponent,
  text,
  payloadJSON,
  testId
}) {
  const [disabled, setDisabled] = useState(false)
  const subidCount = 5
  const vendorsUsingSubid = ['bmg', 'massive', 'admediary', 'seccosquared', 'icommissions']
  const acceptableSubids = ['subid']
  const idApplyParams = {}
  for (let i = 1; i < subidCount + 1; i += 1) {
    acceptableSubids.push(`subid${i}`)
  }
  if (typeof window !== 'undefined') {
    const windowSearchUrl = window.location.search
    const searchParams = new URLSearchParams(windowSearchUrl)
    /* eslint-disable no-restricted-syntax */
    for (const [key, value] of searchParams) {
      vendorsUsingSubid.forEach(vendor => {
        if (window.location.href.includes(vendor)) {
          if (
            acceptableSubids.indexOf(key.toLowerCase()) >= 0 &&
            value.length <= 50 &&
            value.length >= 1
          ) {
            idApplyParams[key] = value
          }
        }
      })
    }
    /* eslint-disable no-param-reassign */
    extraApplyParams = { ...extraApplyParams, ...idApplyParams }
  }

  const onBankingClick = e => {
    let buttonEl = e.target
    if (buttonEl?.localName === 'span') buttonEl = buttonEl.parentNode
    if (buttonEl?.localName !== 'a') return true

    // const emailRegEx = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    const emailValue = buttonEl?.previousElementSibling?.value?.trim()
    const validEmail = emailValue?.length >= 5 && emailValue.indexOf('@') > 0 // emailValue && emailValue.toLowerCase().match(emailRegEx)

    const href = createUrlWithParams('https://mobile-banking.avant.com/apply', extraApplyParams)
    if (validEmail) href.searchParams.set('email', emailValue)
    if (landingKeyword) href.searchParams.set('landing_keyword', landingKeyword)

    window.location.href = href.toString()
    e.preventDefault()
    return false
  }

  const setTracking = async () => {
    const [g2Redirect, keyword] = determineRedirectAndKeyword(landingKeyword)
    landingKeyword = keyword
    let href = ''
    if (g2Redirect) {
      const params = new URLSearchParams(window.location.search)
      const lbterm = params.get('lbterm')
      href = new URL(`${process.env.GATSBY_BASE_URL}/loan/apply/`)
      href.searchParams.set('utm_source', 'creditkarma_lbpa_xl')
      href.searchParams.set('utm_medium', 'lightbox')
      href.searchParams.set('landing_keyword', 'creditkarma_lbpa_xl')
      if (lbterm) href.searchParams.set('utm_term', lbterm)
    } else if (productType?.id === 'mls') {
      href = createUrlWithParams(
        `${process.env.GATSBY_BASE_URL}/${productType.endpoint}/`,
        Object.entries(extraApplyParams)
      )
      href.searchParams.set('landing_keyword', 'avant_card')
      href.searchParams.set('cc_product_type', '3ea00733-a36e-40ae-83a0-faa290dd4046')
      href.searchParams.set('brand', 'MLS')
    } else {
      const filteredParams = Object.entries(extraApplyParams).filter(([key]) => {
        return key !== 'landing_keyword'
      })
      href = createUrlWithParams(
        `${process.env.GATSBY_BASE_URL}/${productType.endpoint || 'apply'}/`,
        filteredParams
      )
      href.searchParams.set('product_type', productType.id)
      if (landingKeyword) href.searchParams.set('landing_keyword', landingKeyword)
    }
    if (window.analytics?.user) {
      href.searchParams.set('segment_id', window.analytics.user().anonymousId())
    }
    if (segmentEvent && window.analytics) {
      window.analytics.track(segmentEvent, {
        location: parentComponent,
        text,
        destination: href.toString(),
        url: window.location.href,
        ...payloadJSON
      })
    }
    window.location.href = href.toString()
  }

  const handleLinkClick = async e => {
    if (disabled) {
      e.preventDefault()
    } else {
      odsData()
      setDisabled(true)
      await setTracking()
    }
  }

  return (
    <LogInContext.Consumer>
      {/* eslint-disable jsx-a11y/anchor-is-valid */}
      {theme => {
        if (productType?.id === 'banking') {
          return (
            <a
              data-test-id={testId}
              className={className}
              onClick={onBankingClick}
              href="https://mobile-banking.avant.com/apply"
              data-event={dataEvent}
              onMouseOver={onMouseOver}
              onFocus={onMouseOver}
            >
              {children}
            </a>
          )
        }

        if (theme.isLoggedIn) {
          return (
            <a
              data-test-id={testId}
              className={className}
              onClick={() => {
                odsData()
                if (segmentEvent && window.analytics) {
                  window.analytics.track(segmentEvent, {
                    location: parentComponent,
                    text,
                    destination: `${process.env.GATSBY_BASE_URL}/dashboard`,
                    url: window.location.href,
                    ...payloadJSON
                  })
                }
              }}
              href="/dashboard"
              data-event="dashboard"
              onMouseOver={onMouseOver}
              onFocus={onMouseOver}
            >
              {children}
            </a>
          )
        }
        return (
          <a
            className={className}
            data-event={dataEvent}
            data-test-id={testId}
            onClick={e => handleLinkClick(e)}
            onKeyDown={e => handleLinkClick(e)}
            role="button"
            tabIndex={0}
            style={disabled ? { cursor: 'not-allowed' } : {}}
            onMouseOver={onMouseOver}
            onFocus={onMouseOver}
          >
            {children}
          </a>
        )
      }}
    </LogInContext.Consumer>
  )
}

AppButtonV3.defaultProps = {
  productType: { id: 'installment', endpoint: 'apply' },
  children: {},
  onMouseOver: null,
  odsData: () => null,
  segmentEvent: null,
  parentComponent: '',
  text: ''
}

AppButtonV3.propTypes = {
  className: PropTypes.string.isRequired,
  /* eslint-disable react/require-default-props */
  dataEvent: PropTypes.string,
  landingKeyword: PropTypes.string,
  /* eslint-enable react/require-default-props */
  productType: PropTypes.object,
  children: PropTypes.node,
  /* eslint-disable react/require-default-props */
  extraApplyParams: PropTypes.object,
  onMouseOver: PropTypes.func,
  odsData: PropTypes.func,
  segmentEvent: PropTypes.string,
  parentComponent: PropTypes.string,
  text: PropTypes.string,
  payloadJSON: PropTypes.object,
  /* eslint-disable react/require-default-props */
  testId: PropTypes.string
}

export default AppButtonV3
